import { gql, useMutation } from '@apollo/client';
import { GET_CURRENT_COMPANY } from './get-current-company.hook';

const UPLOAD_COMPANY_LOGO = gql`
  mutation uploadCompanyLogoById($logo: Upload, $companyId: ObjectId!) {
    uploadCompanyLogoById(logo: $logo, companyId: $companyId) {
      _id
      logoUrl
    }
  }
`;

export const useUploadCompanyLogoById = () => {
  const [uploadCompanyLogoById] = useMutation(UPLOAD_COMPANY_LOGO, {
    refetchQueries: [GET_CURRENT_COMPANY],
  });

  return uploadCompanyLogoById;
};
